import type { PartCondition, PartStockStatus } from "@common/client"
import { formatDecimal } from "@common/lib/number"
import { z } from "zod"

export const STOCK_STATUSES = [
  "available",
  "low",
  "fully_reserved",
  "out_of_stock",
] as const satisfies readonly PartStockStatus[]

export const stockStatusSchema = z.enum(STOCK_STATUSES)

export const CONDITIONS = [
  "new",
  "serviceable",
  "overhauled",
  "repaired",
  "inspected",
  "as_removed",
  "unserviceable",
] as const satisfies readonly PartCondition[]

export const conditionSchema = z.enum(CONDITIONS)

export function formatQuantity(value: string | number): string {
  return formatDecimal(value, 3)
}

export function statusLabel(status: PartStockStatus): string {
  switch (status) {
    case "available":
      return "Available"
    case "low":
      return "Low"
    case "fully_reserved":
      return "Fully reserved"
    case "out_of_stock":
      return "Out of stock"
  }
}

export function conditionLabel(condition: PartCondition): string {
  switch (condition) {
    case "new":
      return "New"
    case "serviceable":
      return "Serviceable"
    case "overhauled":
      return "Overhauled"
    case "repaired":
      return "Repaired"
    case "inspected":
      return "Inspected"
    case "as_removed":
      return "As removed"
    case "unserviceable":
      return "Unserviceable"
  }
}

export function conditionCode(condition: PartCondition): string {
  switch (condition) {
    case "new":
      return "NE"
    case "serviceable":
      return "SV"
    case "overhauled":
      return "OH"
    case "repaired":
      return "RP"
    case "inspected":
      return "IN"
    case "as_removed":
      return "AR"
    case "unserviceable":
      return "US"
  }
}
